// extracted by mini-css-extract-plugin
export default {"quick":"Shoe_quick__vy8mT","image":"Shoe_image__e40H1","flex":"Shoe_flex__cbAnH","h":"Shoe_h__jwccA"};